var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightNceLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6rem",
    viewBox: "0 0 593 324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.2 252.107l32.85-125.512h35.837l48.081 68.362 17.82-68.362h34.343l-30.96 125.512h-33.049l-51.267-71.239-17.72 71.239zM459.204 126.595l-7.367 32.246H380.76s-20.208 1.191-27.176 20.539c-6.969 19.347-7.964 40.084 7.964 40.084h70.678l-8.56 32.544h-79.639s-31.656-6.251-33.547-38.398c-1.892-32.147 16.923-66.973 42.706-80.665 0 0 15.031-6.449 31.656-6.449 16.624 0 74.362.1 74.362.1zM514.85 158.94h69.684l7.366-32.246h-72.968a65.623 65.623 0 0 0-28.57 6.45c-23.394 12.402-43.403 42.168-45.593 71.636l-.298.496h.199a61.214 61.214 0 0 0-.1 8.533c1.792 32.146 33.548 38.397 33.548 38.397h79.638l8.56-32.543h-70.678c-8.561 0-12.145-5.954-12.643-14.486h87.801l7.865-30.361h-88.797c8.263-14.883 24.987-15.875 24.987-15.875z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M127.867 62h-9.427L69 104.951h38.308L69 252h58.867L175 62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29ABE2",
    d: "M156.695 31.428c46.608 0 87.828 25.158 112.878 63.74H307C282.748 39.781 226.159 1 160.387 1 72.36 1 1 70.309 1 155.826A151.001 151.001 0 0 0 33.137 249a160.343 160.343 0 0 1-14.472-67.121c-.1-83.031 61.78-150.45 138.03-150.45z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightNceLogo);
export default __webpack_public_path__ + "static/media/light-nce-logo.8972296c0d69b81907c68ac4fb8403de.svg";
export { ForwardRef as ReactComponent };